import { decryptUsingAES256 } from '../../../../lib/helper';

export const MAX_STEPS = 6;

export const KAM_SOURCE = 'kam';

export const ProfileStateMapping = {
  '10': 0,
  '20': 1,
  '25': 2,
  '30': 3,
  '35': 4,
  '40': 5,
  '45': 6,
  '50': 7,
};

export const StateToProfileMapping = {
  '0': '10',
  '1': '20',
  '2': '25',
  '3': '30',
  '4': '35',
  '5': '40',
  '6': '45',
  '7': '50',
};

export const stateMapping = {
  'Andaman & Nicobar': 'AN',
  'Andhra Pradesh': 'AP',
  'Arunachal Pradesh': 'AR',
  Assam: 'AS',
  Bihar: 'BI',
  'Chandigarh UT': 'CG',
  Chattisgarh: 'CH',
  'Dadra and Nagar Haveli and Daman & Diu': 'DN',
  Delhi: 'DL',
  Goa: 'GA',
  Gujarat: 'GJ',
  Haryana: 'HR',
  'Himachal Pradesh': 'HP',
  'Jammu & Kashmir': 'JK',
  Jharkhand: 'JH',
  Karnataka: 'KT',
  Kerala: 'KR',
  Ladakh: 'LA',
  Lakshadweep: 'LD',
  'Madhya Pradesh': 'MP',
  Maharashtra: 'MH',
  Manipur: 'MN',
  Meghalaya: 'MG',
  Mizoram: 'MZ',
  Nagaland: 'NG',
  Orissa: 'OR',
  'PondiCherry UT': 'PY',
  Punjab: 'PJ',
  Rajasthan: 'RJ',
  Sikkim: 'SK',
  'Tamil Nadu': 'TN',
  Telangana: 'TG',
  Tripura: 'TR',
  Uttaranchal: 'UC',
  'Uttar Pradesh': 'UP',
  'West Bengal': 'WB',
};

export const ProfileMessageMapping = {
  '10': 'Welcome to Plural! Complete your KYC to start accepting payments.',
  '20': 'Complete your KYC to start accepting payments.',
  '25': 'Complete your KYC to start accepting payments.',
  '30': 'Complete your KYC to start accepting payments.',
  '35': 'Complete your KYC to start accepting payments.',
  '40': 'Complete your KYC to start accepting payments.',
  '45': 'Complete your KYC to start accepting payments.',
  '50': 'Pending for KYC Approval.',
  '70': 'KYC has been successfully approved.',
  '80': 'Agreement has been sent to your email for digital signature.',
  '90': 'Thank you for signing the agreement. We are setting up your account.',
  '100':
    'Congratulations, your Plural account has been activated. You can start accepting payment for active payment modes.',
};

export const form2StaticData = {
  IsRewardProgramTypeEnabled: false,
  RewardProgramTypes: null,
  AddonProgramTypes: [
    'Brand EMI',
    'Bank EMI',
    'BRAND_OFFUS_INSTANT_DISCOUNT',
    'BRAND_SUBVENTION_DISCOUNT',
  ],
  PaymentMode: ['CREDIT/DEBIT CARD', 'NETBANKING', 'UPI', 'WALLET'],
  SavedCard: false,
  PartialCapture: false,
  PartialRefund: true,
  IntegrationType: ['REDIRECT', 'iFRAME', 'SEAMLESS'],
  TransactionMode: ['PURCHASE', 'INQUIRY', 'REFUND'],
  IsChargeSlipEnabled: false,
  IsEIPSEnabled: true,
  IsRiskEnabled: false,
  IsIpWhiteListingRequried: false,
  IsAggregatorEnabled: true,
  ExpiryDays: '999',
  IsRetryEnabled: false,
  RetryCount: null,
  IsWebhookEnabled: false,
  WebhookURL: null,
  WebhookEvents: null,
  IsSurchargeFeeEnabled: false,
  EMIModel: ['Cashback Model'],
  IsDynamicRoutingEnabled: false,
  ICBSettlement: false,
  acquirerBank: [
    'ATOM',
    'AXIS',
    'BILL DESK',
    'HDFC CC',
    'HDFC DC',
    'HDFC Felxipay',
    'HDFC TID Request',
    'HDFC UPI',
    'KOTAK',
    'RBL',
  ],
  settlementCycle: '2',
};

export const ProfileData = {
  products: [],
  merchantDetails: {},
  companyauthdetails: {},
  businessinformation: {},
  mandatorydetails: {},
  bankdetails: {},
  uploadDocuments: {},
};

export const keyValueMap = {
  PROOF_OF_IDENTITY: 'Proof of Identity',
  BUSINESS_LEGALITY_PROOF: 'Business Legality Proof',
  PROOF_OF_BUSINESS_ADDRESS: 'Proof of Business Address',
  BANK_ACCOUNT_DETAILS: 'Bank Account Details',
  INDIVIDUAL_PAN: 'PAN Card',
  AADHAAR: 'Aadhaar card',
  PASSPORT: 'Passport',
  VOTER_ID: 'Voter ID card',
  DRIVING_LICENSE: 'Driving License',
  TRADE_LICENSE:
    'Trade License issued by the local authority in the name of the proprietor containing address of the firm.',
  SE_CERTIFICATE:
    'Shop & Establishment Certificate issued by a Civic Authority',
  GST: 'GST Certificate',
  CANCELLED_CHEQUE: 'Cancelled Cheque',
  BANK_STATEMENT: 'Bank Statement',
  PASSBOOK: 'Passbook copy',
  BANK_VERIFICATION_LETTER: 'Bank Verification Letter  ',
};

const constructDocuments = (merchantProfileValue) => {
  const responseList: any = [];
  Object.keys(merchantProfileValue.uploadDocuments).forEach((docategory) => {
    Object.keys(merchantProfileValue.uploadDocuments[docategory]).forEach(
      (docitem) => {
        const fileDetials =
          merchantProfileValue.uploadDocuments[docategory][docitem];
        const response = {
          DocumentType: keyValueMap[docategory],
          DocumentSubType: keyValueMap[fileDetials.documentSubType],
        };
        if (fileDetials?.fileData?.name) {
          response['Title'] = fileDetials.fileData.name;
        }
        if (fileDetials?.fileData?.data) {
          response['VersionData'] = fileDetials.fileData.data;
        }
        responseList.push(response);
      }
    );
  });
  return responseList;
};

export const constructForm2Payload = (
  merchantProfileValue: {
    products: any;
    merchantDetails: any;
    companyauthdetails: any;
    businessinformation: any;
    mandatorydetails: any;
    bankDetails: any;
    uploadDocuments: any;
  },
  merchantDetail: {
    merchantId: string | number;
    merchantName: string;
    merchantPan: string;
    merchantEmail: string;
    leadId: string;
  }
): any => {
  let merchantDetails: any;
  let bankdetails: any;
  try {
    merchantDetails = JSON.parse(decryptUsingAES256(
      merchantProfileValue.merchantDetails,
      merchantDetail.leadId
    ));
  } catch(e){
    merchantDetails = {};
  }

  try {
    bankdetails = JSON.parse(decryptUsingAES256(
      merchantProfileValue.bankDetails,
      merchantDetail.leadId
    ));
  } catch(e){
    bankdetails = {};
  }

  return {
    form2Details: {
      accountInfo: {
        UATMID: `${merchantDetail.merchantId}`,
        LiveMID: null,
        Product: merchantProfileValue.products,
        Name: merchantDetail.merchantName,
        LegalName: merchantDetails.LegalName,
        PAN: merchantDetails.pan,
        GST: merchantDetails.GST,
        Director1_Name: merchantProfileValue.companyauthdetails.Director1_Name,
        Director1_Email:
          merchantProfileValue.companyauthdetails.Director1_Email,
        Director1_PAN: merchantProfileValue.companyauthdetails.Director1_PAN,
        Director2_Name: merchantProfileValue.companyauthdetails.Director2_Name,
        Director2_Email:
          merchantProfileValue.companyauthdetails.Director2_Email,
        Director2_PAN: merchantProfileValue.companyauthdetails.Director2_PAN,
        RnD_Name: merchantProfileValue.companyauthdetails.RnD_Name,
        RnD_Mobile:
          merchantProfileValue.companyauthdetails.RnD_Mobile.slice(-10),
        RnD_Email: merchantProfileValue.companyauthdetails.RnD_Email,
        Settlements_Name:
          merchantProfileValue.companyauthdetails.Settlements_Name,
        Settlements_Mobile:
          merchantProfileValue.companyauthdetails.Settlements_Mobile.slice(-10),
        Settlements_Email:
          merchantProfileValue.companyauthdetails.Settlements_Email,
        Op_Name: merchantProfileValue.companyauthdetails.Op_Name,
        Op_Mobile: merchantProfileValue.companyauthdetails.Op_Mobile.slice(-10),
        Op_Email: merchantProfileValue.companyauthdetails.Op_Email,
        Merchant_Website:
          merchantProfileValue.businessinformation.Merchant_Website,
        ReturnURL: merchantProfileValue.businessinformation.ReturnURL,
        NoOfYearsinBusiness: `${merchantProfileValue.businessinformation.NoOfYearsinBusiness}`,
        AnnualTurnover: `${merchantProfileValue.businessinformation.AnnualTurnover}`,
        MonthlyCardTurnover: `${merchantProfileValue.businessinformation.MonthlyCardTurnover}`,
        ExpectedNoOfTransactions: `${merchantProfileValue.businessinformation.ExpectedNoOfTransactions}`,
        MinTicketSize: `${merchantProfileValue.businessinformation.MinTicketSize}`,
        MaxTicketSize: `${merchantProfileValue.businessinformation.MaxTicketSize}`,
        POCEmail: merchantDetail.merchantEmail,
        NatureOfBusinees:
          merchantProfileValue.businessinformation.NatureOfBusinees,
        BusinessCategory:
          merchantProfileValue.businessinformation.BusinessCategory,
        MerchantBusinessSubCategory: JSON.parse(
          merchantProfileValue.businessinformation.MerchantCategory
        ).subCategory,
        MerchantCategory: JSON.parse(
          merchantProfileValue.businessinformation.MerchantCategory
        ).merchantCategory,
        State:
          stateMapping[
            merchantProfileValue.businessinformation.RegisteredState
          ] || '',
        AddressLine: merchantProfileValue.businessinformation.RegisteredAddress,
        city: JSON.parse(
          merchantProfileValue.businessinformation.RegisteredCity
        ).code,
        Pincode: merchantProfileValue.businessinformation.RegisteredPincode,
        State1:
          stateMapping[
            merchantProfileValue.businessinformation.OperationalState
          ] || '',
        AddressLine1:
          merchantProfileValue.businessinformation.OperationalAddress,
        city1: JSON.parse(
          merchantProfileValue.businessinformation.OperationalCity
        ).code,
        Pincode1: merchantProfileValue.businessinformation.OperationalPincode,
        Privacy_Policy: merchantProfileValue.mandatorydetails.Privacy_Policy,
        Cancellation_Refund_Policy:
          merchantProfileValue.mandatorydetails.Cancellation_Refund_Policy,
        TermsnConditions:
          merchantProfileValue.mandatorydetails.TermsnConditions,
        ProductServiceDesc:
          merchantProfileValue.mandatorydetails.ProductServiceDesc,
        PriceCostInfo: merchantProfileValue.mandatorydetails.PriceCostInfo,
        RelationbnWebsite_LegalName:
          merchantProfileValue.mandatorydetails.RelationbnWebsite_LegalName,
        HelpDesk: merchantProfileValue.mandatorydetails.HelpDesk,
        BankName: `${bankdetails.BankName}`,
        AccountType: bankdetails.AccountType,
        BeneficiaryName: bankdetails.BeneficiaryName,
        AccountNo: bankdetails.AccountNo,
        IFSC: bankdetails.IFSC,
        Remitter1AccountType: bankdetails.Remitter1AccountType || '',
        Remitter1BankAccountNumber:
          bankdetails.Remitter1BankAccountNumber || '',
        Remitter1BankAccountName: bankdetails.Remitter1BankAccountName || '',
        Remitter1BeneficiaryName: bankdetails.Remitter1BeneficiaryName || '',
        Remitter1IFSCcode: bankdetails.Remitter1IFSCcode || '',
        Remitter2AccountType: bankdetails.Remitter2AccountType || '',
        Remitter2BankAccountNumber:
          bankdetails.Remitter2BankAccountNumber || '',
        Remitter2BankAccountName: bankdetails.Remitter2BankAccountName || '',
        Remitter2BeneficiaryName: bankdetails.Remitter2BeneficiaryName || '',
        Remitter2IFSCcode: bankdetails.Remitter2IFSCcode || '',
        ...form2StaticData,
        documents: constructDocuments(merchantProfileValue),
      },
    },
  };
};
